export default __webpack_public_path__ + "static/media/A2.b6387cdc.mp3";